import { render, staticRenderFns } from "./salarySet.vue?vue&type=template&id=449eb2e0&scoped=true&"
import script from "./salarySet.vue?vue&type=script&lang=js&"
export * from "./salarySet.vue?vue&type=script&lang=js&"
import style0 from "./salarySet.vue?vue&type=style&index=0&id=449eb2e0&prod&lang=scss&scoped=true&"
import style1 from "./salarySet.vue?vue&type=style&index=1&id=449eb2e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449eb2e0",
  null
  
)

export default component.exports